(function () {
    'use strict';

    angular
        .module('eclipseApp.core')
        .factory('internetSessionService', internetSessionService)

    internetSessionService.$inject = ['$stateParams', '$rootScope', 'commonService', '$q', '$location'];

    function internetSessionService($stateParams, $rootScope, commonService, $q, $location) {
        var _internetSessionService = {
            setAccountInfo: setAccountInfo
        };

        return _internetSessionService;

        ////////////////////////////////////

        function setAccountInfo() {
            return commonService.getAccountDetails($rootScope.userInfo.accounts).then(function () {
                if ($stateParams.accountNumber && $stateParams.subscriberNo) {
                    $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
                    $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
                } else {
                    if (!$rootScope.userInfo.selectedAccountNumber) {
                        $rootScope.userInfo.selectedAccountNumber = commonService.internetAccountNumber;
                    }
                    if (!$rootScope.userInfo.subscriberNo) {
                        $rootScope.userInfo.selectedSubscriberNo = commonService.internetSubscriberNo;
                    }
                    if (!$stateParams.accountNumber) {
                        $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber || commonService.internetAccountNumber;
                    }
                    if (!$stateParams.subscriberNo) {
                        $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo || commonService.internetSubscriberNo;
                    }
                }

                if (!($stateParams.accountNumber && $stateParams.subscriberNo)) {
                    $location.path('/my-account/overview');
                    return $q.defer().promise;
                } else {
                    return $q.when(true);
                }
            });
        }
    }
})();